import { render, staticRenderFns } from "./ImportadorGeneral.view.vue?vue&type=template&id=f8f73992&"
import script from "./ImportadorGeneral.view.vue?vue&type=script&lang=js&"
export * from "./ImportadorGeneral.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports